<template>
    <div v-show="!closed" class="newsletter-subscribe-overlay">
        <div class="newsletter-subscribe-popup" role="dialog" tabindex="-1" ref="dialog">
            <div v-bind:class="{ 'newsletter-subscribe-popup-header': signed }">
                <div class="d-flex justify-content-between pb-2">
                   <div class="newsletter-subscribe-popup-logo">
                       <logo disableFocus v-if="!signed"></logo>
                    </div>
                    <button v-on:click="close" type="button" class="round-icon-button">
                        <span class="icon-close"></span>
                    </button>
                </div>
                <h1 class="newsletter-subscribe-popup-greetings" v-if="signed">
                    TAK FOR DIN TILMELDING!
                </h1>
            </div>

            <div v-if="!signed">
                <div class="pt-2">
                    <h1>
                      TILMELD DIG KUNSTFONDENS NYHEDSBREV
                    </h1>
                    <p>
                      Vi går tæt på kunst i hele landet, støttede projekter og kunstnerne bag.
                    </p>
                </div>
                <div class="newsletter-subscribe-popup-content">
                    <iframe id="newsletter-subscribe-popup-iframe"
                        title="Subscribe newsletter"
                        src="/typo3conf/ext/kunst_design/Resources/Public/newsletter/iframe.html?v=1">
                    </iframe>
                </div>
                <div class="newsletter-subscribe-popup-footer">
                    Ønsker du information om puljer inden for de enkelte kunstområder?
                    <u><a href="https://www.kunst.dk/abonner">Tilmeld dig her</a></u><br/>
                  <div class="pt-3">
                    Ved tilmelding til Statens Kunstfonds nyhedsbreve, giver du samtidig samtykke til, at
                    Slots- og Kulturstyrelsen behandler oplysningerne i din henvendelse i henhold til
                    <u>
                      <a href="https://www.kunst.dk/kontakt/persondatapolitik" target="_blank">
                        Persondataforordningen</a>.
                    </u>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Cookies from 'js-cookie'
import { startDialogBehaviour, stopDialogBehaviour } from "../../utils/dialog-behaviour";

export default Vue.extend({
    data () {
        return {
            subscribed: false,
            signed: false,
            closed: true
        }
    },
    methods: {
        subscribe: function () {
            this.subscribed = true;
        },
        sign: function () {
            this.signed = true;
            Cookies.set('newsletter', 'approved', { expires: 120 });
        },
        close: function () {
            this.closed = true;
            if (!this.signed) Cookies.set('newsletter', 'declined', { expires: 120 });
            stopDialogBehaviour(this.$refs.dialog);
        }
    },
    created() {
        // NOTE: mounted fires before first event
      if (
          window.location.pathname.substr(1, 26) != 'for-ansoegere/soeg-tilskud'
          && window.location.pathname.substr(1, 7) != 'english'
          && window.location.pathname.substr(1, 7) != 'abonner'
      ) {
        window.addEventListener('CookieInformationConsentGiven', () => {
          // check if cookies consent cookie exists
          const cookiesConsent = !!Cookies.get('CookieInformationConsent');
          if (!cookiesConsent) return;
          // check after 15s if newsletter cookie exists and if not display popup
          setTimeout(() => {
            this.closed = !!Cookies.get('newsletter');
            if (!this.closed) startDialogBehaviour(this.$refs.dialog);
          }, 6000)

        }, false);
      }
    }
});
</script>
